import { Card, Section } from 'barte-design-system'

import { Title, Skeleton } from '@/modules/shared/components'

import { generateCardClasses } from './card-info.constants'

import styles from './card-info.module.css'

import type { CardInfoProps } from './card-info.type'

export const CardInfo = ({ isLoading, info = [{ label: '', value: '' }], title, action, variation = "two-columns", className }: CardInfoProps) => {
    const cardClasses = generateCardClasses(variation)

    if (isLoading) {
        return (
            <div className={`${styles.container} ${className || ''}`}>

                {(title || action) && (
                    <div className={styles['title-group']}>
                        {title && <Title variant='h6' isLoading className={styles['skeleton-title']} />}
                        {action && <Skeleton className={styles['skeleton-action']} />}
                    </div>
                )}

                <Card>
                    <div className={cardClasses}>
                        {
                            info?.map((item, index) => (
                                <div key={index} className={`${styles.item} ${item.className || ''}`}>
                                    {item.label && <Skeleton className={styles['skeleton-label']} />}
                                    <Skeleton className={styles['skeleton-value']} />
                                </div>
                            ))
                        }
                    </div>
                </Card>
            </div>
        )
    }

    return (<div className={`${styles.container} ${className || ''}`}>
        {(title || action) && (
            <div className={styles['title-group']}>
                <Title variant='h6'>{title}</Title>
                {action}
            </div>
        )}


        <Card >
            <div className={cardClasses}>
                {info?.map((item, index) => (
                    <div key={index} className={`${styles.item} ${item.className || ''}`}>
                        {item.label && <span className={styles.label}>{item.label}</span>}
                        <span className={styles.value}>{item.value}</span>
                    </div>
                ))}
            </div>
        </Card>
    </div>
    )
}